<ml-host-name-ui (hostName)="hostName($event)"></ml-host-name-ui>